import { Component, Inject, Optional } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DialogRef,
  DialogService,
  DIALOG_DATA,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { Environment } from '@cyborg-monorepo/hunter/common';
import { EnvironmentService } from '../../../../shared/services/environment.service';

@Component({ standalone: false, 
  selector: 'delete-environment-dialog',
  templateUrl: './delete-environment-dialog.component.html',
  styleUrls: ['./delete-environment-dialog.component.scss'],
})
export class DeleteEnvironmentDialogComponent {
  public formGroup: FormGroup;
  public error: string;

  constructor(
    public dialogRef: DialogRef,
    public dialogService: DialogService,
    public environmentService: EnvironmentService,
    @Optional() @Inject(DIALOG_DATA) public environment: Environment,
  ) {}

  public onSubmit(): void {
    this.environmentService.deleteEnvironment(this.environment.id).subscribe(
      () => {
        this.dialogRef.close(this.environment);
      },
      (error) => {
        this.error = error.message;
      },
    );
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
